const translations = {
  "en": {
    "By selecting \"Continue\", you agree to the Alnvest user terms, Privacy Policy and Third Party Brokerage Disclaimer": "By selecting \"Continue\", you agree to the Ed user terms, Privacy Policy and Third Party Brokerage Disclaimer"
  },
  "zh-tw": {
    "By selecting \"Continue\", you agree to the Alnvest user terms, Privacy Policy and Third Party Brokerage Disclaimer": "選擇「繼續」即表示你同意 Ed 用戶條款、隱私權政策及第三方經紀商聲明"
  }
};

export default translations;
